import React from "react";
import {makeStyles, Typography} from "@material-ui/core";

import ProductVariant from "../ProductVariant";
import {useSelector} from "react-redux";
import isEmpty from 'lodash/isEmpty';
import Grid from "@material-ui/core/Grid";
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import {isWidthDown} from "@material-ui/core/withWidth";
import { Availability } from '../Availability';

const useStyles = makeStyles(
    (theme) => ({
        componentTile: {
            paddingBottom: 5,
            display: "flex",
            flexDirection: "row",
            alignItems: 'center'
        },
        componentTitle: {
            fontWeight: 'bold',
            width: '180px',
            textWrap: 'wrap'
        },
        optionTitles: {},
        articleNumbers: {},
        optionPrices: {
            fontStyle: "italic"
        },
        selectedComponentGroup: ({ width, showReceiveOfferForm, amountData }) => ({
            position: 'relative',
            display: 'grid',
            width: '440px',
            gridAutoFlow: !showReceiveOfferForm && !isWidthDown('sm', width) ? 'column' : '',
            gridTemplateRows:
                !showReceiveOfferForm && !isWidthDown('sm', width)
                    ? 'repeat(' + Math.round(amountData.length / 2) + ', auto)'
                    : '',
        }),
        componentGroupTitle: {
            fontWeight: 'bold',
            width: '180px',
            textWrap: 'wrap',
            fontSize: '20px !important',
            paddingTop: 20,
            paddingBottom: 5
        },
        articleNumber: {
            paddingTop: 25,
            paddingBottom: 5
        }
    }),
    {name: "CustomProductVariant"}
);

const CustomProductVariant = (props) => {
    const classes = useStyles({});

    const ComponentTile = ({component}) => {
        let optionTitles = (component.selectedoptions.map((option) => option.title)).join(', ');
        const optionPrices = (component.selectedoptions.map((option) => option.priceFormatted)).join(', ');
        const articleNumberAttributes = (component.selectedoptions.map((option) => option.attributes.filter((attribute) => attribute.identifier === 'articlenumber'))).filter((optionAttr) => !isEmpty(optionAttr));
        const articleNumbers = isEmpty(articleNumberAttributes) ? null : (articleNumberAttributes.map((attribute) => attribute[0].values[0].value)).join(', ');
        if (articleNumbers) {
            optionTitles = `${optionTitles} (${articleNumbers})`;
        }
        return (
            <div className={classes.componentTile}>
                <Typography className={classes.componentTitle}>{component.title}</Typography>
                <div>
                    <Typography className={classes.optionTitles}>{optionTitles ? optionTitles : "-"}</Typography>
                    {articleNumbers &&
                        <Typography className={classes.optionPrices}>{optionPrices}</Typography>
                    }
                </div>
            </div>
        );
    }

    const ComponentTitle = ({componentIdentifier, tableSet}) => {
        const component = tableSet["components"][componentIdentifier];
        const articleNumber = component ? component.articleNumber + ", " : "";
        const price = component ? component.totalPriceFormatted : "";

        const availability = <Availability groupIdentifier={componentIdentifier} component={"span"} variant={"body2"}/>;

        return (
            <div className={classes.componentTile}>
                <Typography className={classes.componentGroupTitle}>{t(componentIdentifier)}</Typography>
                <div>
                    <Typography className={classes.articleNumber}>{articleNumber} <b>{price}</b>{availability && ', '}{availability}</Typography>
                </div>
            </div>
        );
    }

    const {
        components,
    } = useSelector((state) => ({
        components: state.configurator.configuration.optionclassifications,
    }));

    const groupedComponents = useSelector((state) => ({
        components: state.configurator.configuration.information.components,
    }));

    const tableSetInfo = useSelector((state) => ({
        components: state.configurator.configuration.information.tableSet,
    }));

    return (
        <>
            <ProductVariant {...props}/>
            {groupedComponents.components ?
                (<Grid container>
                    <Grid item className={classes.selectedComponentGroup}>
                        <ComponentTitle componentIdentifier={"table"} tableSet={tableSetInfo}/>
                        {groupedComponents.components[0].components.map((component) =>
                            <ComponentTile key={component.identifier} component={component}/>)}
                    </Grid>
                    <Grid item className={classes.selectedComponentGroup}>
                        <ComponentTitle componentIdentifier={"chairs"} tableSet={tableSetInfo}/>
                        {groupedComponents.components[1].components.map((component) =>
                            <ComponentTile key={component.identifier} component={component}/>)}
                    </Grid>
                    <Grid item className={classes.selectedComponentGroup}>
                        <ComponentTitle componentIdentifier={"covers"} tableSet={tableSetInfo}/>
                        {groupedComponents.components[2].components.map((component) =>
                            <ComponentTile key={component.identifier} component={component}/>)}
                    </Grid>
                </Grid>) :
                components && components.map((component) => <ComponentTile key={component.title} component={component}/>)
            }
        </>
    );
};

export default CustomProductVariant;
